export const isNumeric = (value: string) => {
  const parsedValue = Number(value);

  return !isNaN(parsedValue);
};
